import React from 'react';
import { Block } from '@uncinc/react-drupal-core';

const ParagraphBlockReference = ({ entity }) => {
  const data = entity.getIn(['field_block_reference', 0, 'entity']);
  const target_id = entity.getIn(['field_block_reference', 0, 'target_id']);

  return (
    <div>
      <Block
        id={target_id}
        entity={data}
      />
    </div>
  );
};

export default ParagraphBlockReference;
